import React from 'react';

import SectionSubTitle from '../../ticketForm/components/SectionSubTitle';
import { SectionBody } from '../../ticketForm/components/SectionBody';
import { SectionLine } from '../../ticketForm/components/SectionLine';
import { CustomSpace } from '../../ticketForm/components/CustomSpace';
import Separator from 'modules/emergencies/components/ui/layout/Separator';
import Information from '../../ui/icon/information';
import { Tooltip } from '@ontruck/orc';
import { BidTooltip } from '../../ticketsList/ticketsListTable/tooltips';
import BasicLoader from '../../ui/loaders/basicLoader';
import { ToolbarButtonComponent } from '@ontruck/fe-ui';
import useAddBidModal from '../../modals/useAddBidModal';
//styles
import styled, { css } from 'styled-components';
import ticketService from 'modules/emergencies/ticketService';
import Star from '../../ui/icon/star';

const CustomVerticalSeparator = styled(Separator)`
  height: 16px;
`;

const BidSectionLine = styled(SectionLine)`
  padding-left: 16px;
  min-height: 48px;
  padding-top: 4px;
  padding-bottom: 4px;
  ${(props) =>
    !!props.isSuggested &&
    css`
      background: white;
      border-left: 4px solid var(--accent-color-blue);
    `}
  cursor: pointer;
`;

const CustomSectionSubTitle = styled(SectionSubTitle)`
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: 100%;
  ${ToolbarButtonComponent} {
    font-size: 14px;
  }
`;

const CustomSubtitle = styled(SectionSubTitle)`
  color: var(--grey500);
  margin: 0 auto;
`;

const RightSide = styled(SectionLine)`
  gap: 16px;
  justify-content: right;
  flex-grow: 1;
`;

const BidCostContainer = styled.div`
  display: flex;
  width: 80px;
  justify-content: end;
`;
const LeftSide = styled(SectionLine)`
  align-items: center;
  flex-grow: 1;
  flex-direction: row;
  input {
    transform: scale(1.5);
  }
  gap: 16px;
`;
const BidTitle = styled.div`
  font-size: 14px;
  color: var(--grey700);
`;
const BidSubtitle = styled.div`
  font-size: 12px;
  color: var(--grey700);
`;
const BasicLoaderStyled = styled(BasicLoader)`
  margin: 2px auto;
`;

const t = {
  section_title: 'Supply info',
  cost_subtitle: 'Cost options',
  carrier_subtitle: 'Assigned carrier',
  no_bids: 'No reply has been received from the carriers yet',
  add_bid: 'Add bid',
};

export const QuoteBidSection = ({
  bids,
  isLoadingTicket,
  ticketDetail,
  onBidSelection,
  selectedBid,
}) => {
  const { openAddBidModal } = useAddBidModal(ticketDetail);
  const suggestedBid = isLoadingTicket ? null : ticketService.bussiness.getSuggestedBid(bids);

  return (
    <>
      <CustomSectionSubTitle>
        {t.cost_subtitle}
        <ToolbarButtonComponent
          onClick={() => {
            openAddBidModal();
          }}
        >
          {t.add_bid}
        </ToolbarButtonComponent>
      </CustomSectionSubTitle>
      <SectionBody>
        <Separator />
        {isLoadingTicket ? (
          <>
            <BasicLoaderStyled size={14} />
            <Separator />
          </>
        ) : (
          <>
            {bids.length > 0 ? (
              <div style={{ width: '100%' }}>
                {bids.map((bid) => (
                  <React.Fragment key={`section-line-${bid.id}`}>
                    <BidSectionLine
                      isSuggested={bid.id === suggestedBid?.id}
                      key={`section-line-${bid.id}`}
                      onClick={() => onBidSelection(bid)}
                    >
                      <LeftSide>
                        <input
                          onChange={() => {}}
                          type="checkbox"
                          checked={bid.id === selectedBid?.id}
                          name={`bid-${bid.id}-checkboc`}
                        />
                        <div>
                          <BidTitle>
                            {`${bid.bidder?.carrier?.name} - ${bid.bidder?.first_name}`}
                          </BidTitle>
                          {bid.bidder?.carrier?.email && (
                            <BidSubtitle>{bid.bidder?.carrier.email}</BidSubtitle>
                          )}
                        </div>
                      </LeftSide>
                      <RightSide>
                        {/* rating */}
                        <CustomVerticalSeparator vertical />
                        {bid.bidder?.carrier?.rating && (
                          <>
                            <Star /> {bid.bidder?.carrier.rating}
                            <CustomVerticalSeparator vertical />
                          </>
                        )}
                        <BidCostContainer>
                          {bid.cost.amount} {bid.cost.currency}
                        </BidCostContainer>
                        <CustomVerticalSeparator vertical />
                        {!!bid.conditions ? (
                          <Tooltip
                            component={<BidTooltip content={bid.conditions} />}
                            position="bottom"
                            skin="dark"
                          >
                            <Information blue />
                          </Tooltip>
                        ) : (
                          <Information />
                        )}
                      </RightSide>
                    </BidSectionLine>
                    <Separator key={`separator-line-${bid.id}`} />
                  </React.Fragment>
                ))}
              </div>
            ) : (
              <>
                <SectionLine>
                  <CustomSubtitle>{t.no_bids}</CustomSubtitle>
                </SectionLine>
                <Separator />
              </>
            )}
          </>
        )}
      </SectionBody>
      <CustomSpace />
    </>
  );
};
